/**
 * THIS IS GENERATED CODE!
 * PLEASE DO NOT MODIFY - ALL YOUR WORK WOULD BE LOST!
 */
export const typescriptDeclarationFixConstant = 1;
export enum UiFloatingComponentPosition {
	TOP_LEFT = "top-left", TOP_RIGHT = "top-right", BOTTOM_LEFT = "bottom-left", BOTTOM_RIGHT = "bottom-right"
}